import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { HolidayConfigModal } from "./HolidayConfigModal";

const HolidayConfig = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [modalFields, setModalFields] = useState([
    {
      label: "Holiday Name",
      name: "name",
      type: "text",
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Date",
      name: "date",
      type: "date",
      required: true,
    },
    {
      label: "Remarks",
      name: "remarks",
      type: "textarea",
      placeholder: "Please Enter",
      customcolspan: 12,
    },
  ]);
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});

  const [bankData, setBankData] = useState([]);
  const [targetFileId, setTargetFileId] = useState("");

  const [rowcount, setRowcount] = useState(0);
  const columns = [
    {
      dataIndex: "name",
      title: "Holiday Name",
      render: (text) => {
        return <h6 className="text-primary">{text}</h6>;
      },
    },
    {
      dataIndex: "date",
      title: "Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.date) {
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "remarks",
      title: "Remarks",
    },
  ];

  const onPageChange = (pageData) => {
    setSearch((prevState) => ({
      ...prevState,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    }));
  };

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const getHolidays = () => {
    let payload = {
      ...search,
    };
    props.apis.apiGetMasterHolidays(payload).then(({ data, total }) => {
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const viewHoliday = (record) => {
    openModal();
    setEditmode(false);
    setViewmode(true);
    props.apis.apiGetMasterHolidayById({ id: record.id }).then((data) => {
      let filteredData = Object.only(
        data,
        modalFields.map((v) => v.name)
      );
      setPopupdata(filteredData);
      setEditData(data);
    });
  };

  const editHoliday = (record) => {
    setEditmode(true);
    setViewmode(false);

    props.apis.apiGetMasterHolidayById({ id: record.id }).then((data) => {
      let filteredData = Object.only(
        data,
        modalFields.map((v) => v.name)
      );
      setPopupdata(filteredData);
      setEditData(data);
      openModal();
    });
  };

  const deleteHoliday = (record) => {
    swal2
      .fire({
        title: "Are you sure you want to delete this holiday?",
        icon: "warning",
        iconColor: "#BB1766",
        showCancelButton: true,
        confirmButtonColor: "#BB1766",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes, delete it!",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis.apiDeleteMasterHoliday({ id: record.id }).then((res) => {
            swal2.fire({
              title: "Holiday Deleted",
              text: "Holiday deleted successfully !!",
              icon: "success",
              iconColor: "#BB1766",
              timer: 4000,
            });
            getHolidays();
          });
        }
      });
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    let payload = {
      ...data,
      date: new Date(data?.date).toISOString(),
    };

    if (editmode) {
      props.apis
        .apiUpdateMasterHoliday(payload, {
          id: editData?.id,
        })
        .then((res) => {
          swal2.fire({
            title: "Holiday updated successfully.",
            icon: "success",
            iconColor: "#BB1766",
            timer: 4000,
          });
          closeModal();
          getHolidays();
        });
    } else {
      props.apis.apiAddMasterHoliday(payload).then((res) => {
        swal2.fire({
          title: "Holiday added successfully.",
          icon: "success",
          iconColor: "#BB1766",
          timer: 4000,
        });
        closeModal();
        getHolidays();
      });
    }
  };

  const addModalFields = (values) => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
  };

  useEffect(() => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    setPopupfields(fields);
  }, [editData]);

  useEffect(() => {
    getHolidays();
  }, [search]);

  props.$setNode({
    props,
    bankData,
    targetFileId,
  });

  return (
    <>
      <div className="page_header mb-3 text-end">
        <Link
          to={"#"}
          className="btn btn-primary btn-sm ms-1"
          onClick={(...args) => addModalFields(...args)}
        >
          + Add New
        </Link>
      </div>
      <AppTable
        data={tableData}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        editAction={(...args) => editHoliday(...args)}
        viewAction={(e) => viewHoliday(e)}
        deleteAction={(e) => deleteHoliday(e)}
        loading={isFetching}
      ></AppTable>

      <HolidayConfigModal
        id="holidayCanvas"
        title={`${editmode ? "Edit Holiday" : viewmode ? "View Holiday" : "Add Holiday"
          }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Add"}`}
        disableallfields={viewmode ? true : false}
      />
    </>
  );
};

export default constore(HolidayConfig);
